// extracted by mini-css-extract-plugin
export var fullGrid = "_3h-3";
export var pdpPreviewContainer = "_3h-1";
export var previewContainer = "_3h-0";
export var togglePreviewContainer = "_3h-2";